import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandIq } from '../../../brandiq.setup';

const parent: SetupPage = BrandIq.pages.brandiqBasic;
const path = 'data-collection-funnel';
const title = 'PAGE.BRANDIQ.BRANDIQ_BASIC.DATA_COLLECTION_FUNNEL.TITLE';
const res = [];

export const BrandIqDataCollectionFunnelTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
